import { Control } from 'superlikers-dynamic-forms'

export const loginControls: Control[] = [
  {
    placeholder: 'Correo',
    name: 'email',
    controlType: 'input',
    type: 'text',
    validators: {
      required: true
    }
  },
  {
    placeholder: 'Contraseña',
    name: 'password',
    controlType: 'input',
    type: 'password',
    validators: {
      required: true
    }
  }
]
